
export default {
	name: 'IqosLogo',
};
